import camelCase from 'camelcase'
import DemoSearch from './DemoSearch'
import Cell0Contact from './Cell0Contact'

const components = {
    DemoSearch,
    Cell0Contact,
    Cell0About: Cell0Contact, // alias
}

export function componentName (intent) {
    if (!intent) {
        return null
    }

    const name = camelCase(intent, { pascalCase: true })
    if (!components[name]) {
        return null
    }

    return name
}

export default components
